var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"visible":_vm.isBusy}},[_c('BasicTableNoPagination',{attrs:{"fields":_vm.fields,"table-data":_vm.filterData()},on:{"onSelect":_vm.onSelect}})],1),_c('PermissionBasicSidebar',{ref:"sidebar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }